import * as React from 'react';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
export const ActionBar = ({ history }) => (
  <>
    <ColumnManager agenda={Agenda.REPAIRS} />
    <div style={{ marginLeft: 5 }}>
      <Button label="Oprava" type="button" onClick={() => history.push('/repairs/repair')} />
      <Button label="Údržba" type="button" onClick={() => history.push('/repairs/maintenance')} />
    </div>
  </>
);



// WEBPACK FOOTER //
// ./src/modules/repairs/RepairsGridButtons.tsx